import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { SweetAlertService } from 'src/app/services/sweetalert.service';

@Component({
  selector: 'app-resend-email',
  templateUrl: './resend-email.component.html',
  styleUrls: ['./resend-email.component.scss']
})
export class ResendEmailComponent implements OnInit {
  resendForm!: FormGroup;
  submitted = false;
  loading = false;
  emailSent = false;
  errorMessage = '';
  currentYear = new Date().getFullYear();

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private sweetAlertService: SweetAlertService
  ) {}

  ngOnInit(): void {
    this.resendForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  get form(): { [key: string]: AbstractControl } {
    return this.resendForm.controls;
  }

  onSubmit(): void {
    this.submitted = true;
    this.errorMessage = '';

    if (this.resendForm.invalid) {
      return;
    }

    this.loading = true;


    this.authService.resendVerification(this.resendForm.value).subscribe({
      next: (data: any) => {
        this.loading = false;
        this.emailSent = true;

        this.sweetAlertService.toastSuccess('Email envoyé avec succès !', 3000);

        // Redirection après 3 secondes
        setTimeout(() => {
          this.router.navigate(['/auth/signin']);
        }, 3000);
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        this.errorMessage = error.error?.detail ||
                           error.error?.error ||
                           'Le service est temporairement indisponible';

        this.sweetAlertService.toastError(
          'Erreur !',
          5000,
          this.errorMessage
        );
      }
    });

  }


  resetForm(): void {
    this.resendForm.reset();
    this.submitted = false;
    this.errorMessage = '';
    Object.keys(this.resendForm.controls).forEach(key => {
      this.resendForm.controls[key].setErrors(null);
    });
  }

  goToSignin(): void {
    this.router.navigate(['/auth/signin']);
  }

  goToSignup(): void {
    this.router.navigate(['/auth/signup']);
  }

  getFieldError(fieldName: string): string {
    const field = this.resendForm.get(fieldName);

    if (field?.hasError('required')) {
      return 'Ce champ est requis';
    }
    if (field?.hasError('email')) {
      return 'Email invalide';
    }

    return '';
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.resendForm.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched || this.submitted));
  }
}
